import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, computed, ref } from 'vue';
import { Field, DropdownField } from '@samc/centricity-core';
import { TaskTemplateSource } from '@/Sources';


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskTemplateDropdownField',
  props: {
    value: { type: [Number, null], required: false },
    label: { type: String, required: false, default: 'Template' },
    disabled: { type: Boolean, required: false, default: false },
    clearable: { type: Boolean, required: false, default: true },
    placeholder: { type: String, required: false, default: 'Select Template' },
    errorText: { type: String, required: false, default: '' },
    isDeal: { type: Boolean, required: false, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit: $emits }: { emit: ({ (event: 'input', value: number | null): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: number | null, label: string, disabled: boolean, clearable: boolean, placeholder: string, errorText: string, isDeal: boolean };





const source = ref(new TaskTemplateSource(props.isDeal));

const val = computed({
  get: () => props.value ?? null,
  set: (value: number | null) => $emits('input', value)
});

return { __sfc: true,props, $emits, source, val, Field, DropdownField }
}

})